import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import styled from "styled-components"
import dateConverter from "../../helper/dateConverter"
const Container = styled.div`
    display: flex;
    align-items: center;
    border: 1px solid;
    border-color: ${({ isError }) => isError ? " #BB2649": "transparent"};
    label{
        font-size: 16px;
        font-weight: var(--font-weight-md);
        line-height: 12px;
        text-align: left;
        padding: 10px;
        width: ${({labelWidth})=> labelWidth};
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.secondaryBgColor};
        border-radius: 5px 0px 0px 5px;
        height: 32px;
    }
    
    input{
        font-size: 16px;
        font-weight: var(--font-weight-md);
        line-height: 16px;
        text-align: left;
        padding: 10px;
        width: ${({inputWidth})=> inputWidth};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border-radius: 0px 5px 5px 0px;
        height: 32px;
        font-variant-numeric: lining-nums;

        &::-webkit-calendar-picker-indicator{
          filter: ${({theme})=> theme.inputDateIconColor};
        }
    }

`

const InputGroupDate = ({handleChange, isRequired, labelText, value, name, inputType,labelWidth,inputWidth, isSubmitted, requiredFields}) => {
  const [isError, setIsError] = useState(false)

  const {theme} = useSelector(state => state.layout)

  useEffect(()=> {
    if(isSubmitted && requiredFields && !value){
      if (requiredFields.includes(name)){
        setIsError(true)
      }
    }
    else{
      setIsError(false)
    }
  },[isSubmitted, requiredFields, value])

  return (
    <Container isDarkTheme={theme === "dark"} labelWidth={labelWidth} inputWidth={inputWidth} isError={isError}>
        <label htmlFor={name}>{labelText} {isRequired && "*"}</label>
        <input id={name} name={name} type={inputType} value={dateConverter(value, value.includes(".") ? "us": "us-2")} onChange={handleChange} />
    </Container>
  )
}

export default InputGroupDate